import React, { Component } from 'react'
import { Button, Modal, ModalHeader, ModalBody, ModalFooter, Form, FormGroup, Label, Table } from 'reactstrap';
import DropDown from 'shared/components/DropDown/index';
import Input from 'shared/components/Input/index';
import ActionButton from 'shared/components/ActionButton/index';
import DatePicker from 'react-datepicker';
import moment from 'moment';
import 'react-datepicker/dist/react-datepicker.css';


export default class SchedulingModel extends Component {

  render() {
    return (
      <Modal isOpen={this.props.isOpen} toggle={this.props.toggle} className={this.props.className}>
        <ModalHeader toggle={this.props.toggle}>Schedule Periodical </ModalHeader>
        <ModalBody>
        
          <Form>
          <div className="row">
              <div className="col-md-12">
                <FormGroup>
                  <Label>Periodical Name</Label><br/>
                  {this.props.periodical_name}
                </FormGroup>
              </div>
            
            </div>

            <div className="row">
              <div className="col-md-6">
                <FormGroup>
                  <Label>Frequency</Label><br/>
                  {this.props.frequency_data.map(f=>{
                      return(
                     <span key={f.id}> {f.id===this.props.frequency?f.name:''}</span>
                      )
                    })}

                </FormGroup>
              </div>
              <div className="col-md-6">
                <FormGroup>
                  <Label>Occuarances Count In Frequency</Label><br/>
                  <Label>{this.props.occurrence_count}</Label>
                </FormGroup>
              </div>
            </div>
            <div className="row">
              <div className="col-md-6">
                <FormGroup>
                  <Label>Start Date </Label>
                  {/* <Input type={"date"}  name={"pstart_date"} min={this.props.min}  value={this.props.pstart_date} placeholder={""}   onChange={this.props.pendStartDate} /> */}
                  <DatePicker selected={this.props.pstart_date} name={"pstart_date"}  maxDate={this.props.pend_date} withPortal fixedHeight onChange={this.props.pendStartDate} className="form-control"  dateFormat="DD-MM-YYYY"/>
                  <span className="error-text">{this.props.validator.message('pstart_date', this.props.pstart_date, 'required',false,{default: 'This field is required.'})}</span>
                </FormGroup>
              </div>
              <div className="col-md-6">
                <FormGroup>
                  <Label>End Date</Label>
                  {/* <Input type={"date"} name={"pend_date"}  placeholder={""} readOnly={true}  value={this.props.pend_date}  /> */}
                  <DatePicker selected={this.props.pend_date} name={"pend_date"}  disabled  className="form-control"   dateFormat="DD-MM-YYYY"/>
                  <span className="error-text">{this.props.validator.message('pend_date', this.props.pend_date, 'required',false,{default: 'This field is required.'})}</span>
                </FormGroup>
              </div>
            </div>
            
          </Form>
        </ModalBody>
        <ModalFooter>
          <br/>
          <br/>
          <ActionButton color={"primary"} size={"md"} button_name={"Save & Close"} button_click={this.props.pendingModelSubmitClick}/>{' '}
          <Button color={"danger"} size={"md"} onClick={this.props.toggle}>Cancel</Button>
        </ModalFooter>
      </Modal>
    )
  }
}




// WEBPACK FOOTER //
// ./src/shared/components/Models/pending_scheduling_model.js